/* Habit Heroes Holiday Sets page (holiday 2026), ported from bogo/preview/sets.js.
   Gallery slides, set chooser, real cart add, pre-order questions, review dots. No libraries.
   Every visible string lives in the section's HTML (settings / data-hh-msg); this file only moves state.
   Chooser: three radios bound to the product's variants (data-variant, written by Liquid from
   product.variants) and two set cards. One card on = that set, both = Both Sets, none = nothing chosen and
   the cart disabled; choosing a row sets the cards. Loads with Both Sets. The form carries the chosen
   variant id and the fixed properties[Ships] input; Shopify's payment button reads the same form. */
(function () {
  'use strict';

  var d = document;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, root) { return (root || d).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); };

  function makeAlert(root) {
    var el = $('[data-hh-alert]', root);
    var msgEl = $('[data-hh-alert-message]', root);
    var closeBtn = $('[data-hh-alert-close]', root);
    var returnFocus = null;
    function message(key) {
      var m = $('[data-hh-msg="' + key + '"]', root);
      return m ? m.textContent : '';
    }
    function show(key) {
      if (!el) return;
      msgEl.textContent = message(key);
      returnFocus = d.activeElement;
      el.hidden = false;
      closeBtn.focus();
    }
    function hide() {
      if (!el || el.hidden) return;
      el.hidden = true;
      if (returnFocus && returnFocus.focus) returnFocus.focus();
    }
    if (closeBtn) closeBtn.addEventListener('click', hide);
    if (el) el.addEventListener('click', function (e) { if (e.target === el) hide(); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    return { show: show, hide: hide, message: message };
  }

  /* ---------------------------------------------------------------- gallery (slides, so the CSS stand-ins work) */
  function initGallery(root) {
    var g = $('[data-hh-gallery]', root);
    if (!g) return;
    var strip = $('[data-hh-gallery-thumbs]', g);
    var thumbs = $$('.hh-pdp-thumb', g);
    if (!strip || thumbs.length < 2) return;
    var index = 0, timer = null, stopped = false, hovering = false;

    function scrollStripTo(btn) {
      var s = strip.getBoundingClientRect(), b = btn.getBoundingClientRect();
      if (b.left < s.left || b.right > s.right) {
        strip.scrollTo({ left: strip.scrollLeft + (b.left - s.left), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
    function show(i) {
      index = (i + thumbs.length) % thumbs.length;
      thumbs.forEach(function (t, k) {
        var slide = d.getElementById(t.getAttribute('aria-controls'));
        if (!slide) return;
        var on = k === index;
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        if (on && slide.hidden) {
          slide.classList.remove('hh-is-in'); void slide.offsetWidth; slide.classList.add('hh-is-in');
          $$('img[loading="lazy"]', slide).forEach(function (img) { img.loading = 'eager'; });
        }
        slide.hidden = !on;
      });
      scrollStripTo(thumbs[index]);
    }
    function tick() { if (!hovering) show(index + 1); }
    function start() {
      if (window.Shopify && window.Shopify.designMode) return;
      if (!stopped && !reduceMotion && !timer) timer = setInterval(tick, 5000);
    }
    function stop() { stopped = true; clearInterval(timer); timer = null; }

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { stop(); show(i); });
    });
    g.addEventListener('mouseenter', function () { hovering = true; });
    g.addEventListener('mouseleave', function () { hovering = false; });
    g.addEventListener('focusin', stop);
    g.addEventListener('pointerdown', stop);
    start();
  }

  /* ---------------------------------------------------------------- set chooser + cart */
  function initChooser(root, alerts) {
    var chooser = $('[data-hh-chooser]', root);
    if (!chooser) return;
    var rows = $$('.hh-opt-row__input', chooser);              // radios: set1 / set2 / both
    var cards = $$('.hh-set-input', chooser);                  // checkboxes: set1 / set2
    var form = $('form[data-hh-cart-form]', chooser);
    if (!rows.length || !form) return;
    var idInput = $('input[name="id"]', form);
    var actions = $('[data-hh-cart-actions]', form);
    var addBtn = $('[data-hh-add]', form);
    var pay = $('[data-hh-pay]', form);
    var cartResponse = $('[data-hh-cart-response]', chooser);
    var priceName = $('[data-hh-price-name]', root);
    var priceFrom = $('[data-hh-price-from]', root);
    var priceNow = $('[data-hh-price-now]', root);
    var priceWas = $('[data-hh-price-was]', root);
    var fromPrice = priceFrom ? priceFrom.getAttribute('data-from') : '';

    function rowFor(value) { return rows.filter(function (r) { return r.value === value; })[0] || null; }
    function cardFor(value) { return cards.filter(function (c) { return c.value === value; })[0] || null; }
    function chosen() { return rows.filter(function (r) { return r.checked; })[0] || null; }

    /* cards → row: one card on = that set; both on = Both Sets; none = nothing chosen */
    function rowFromCards() {
      var on = cards.filter(function (c) { return c.checked; }).map(function (c) { return c.value; });
      var value = on.length === 2 ? 'both' : on.length === 1 ? on[0] : null;
      var target = value && rowFor(value);
      rows.forEach(function (r) { r.checked = !!target && r === target && !r.disabled; });
    }
    /* row → cards */
    function cardsFromRow(value) {
      var c1 = cardFor('set1'), c2 = cardFor('set2');
      if (c1) c1.checked = value === 'set1' || value === 'both';
      if (c2) c2.checked = value === 'set2' || value === 'both';
    }

    function render() {
      var row = chosen();
      var enabled = !!row;

      rows.forEach(function (r) { r.closest('.hh-opt-row').classList.toggle('hh-is-active', r.checked); });
      cards.forEach(function (c) { c.closest('.hh-set-item').classList.toggle('hh-is-selected', c.checked); });

      /* panel price: copied from the chosen row's own text */
      if (priceNow) {
        if (priceWas) priceWas.textContent = '';
        if (row) {
          var box = row.closest('.hh-opt-row');
          var was = $('[data-hh-row-was]', box);
          var rn = $('[data-hh-row-name]', box);
          if (priceName) { priceName.textContent = rn.getAttribute('data-row-label') || rn.textContent; priceName.hidden = false; }
          priceNow.textContent = $('[data-hh-row-price]', box).textContent;
          if (was && priceWas) $$('span', was).forEach(function (s) { priceWas.appendChild(s.cloneNode(true)); });
          if (priceFrom) priceFrom.hidden = true;
        } else {
          if (priceName) priceName.hidden = true;
          if (priceFrom) priceFrom.hidden = false;
          priceNow.textContent = fromPrice;
        }
      }

      /* form: the chosen variant id (the Ships property is a fixed hidden input) */
      var id = row ? row.getAttribute('data-variant') : '';
      if (idInput.value !== id) {
        idInput.value = id;
        idInput.dispatchEvent(new Event('input', { bubbles: true }));
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      idInput.disabled = !row;
      actions.classList.toggle('hh-is-disabled', !enabled);
      addBtn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      if (enabled && cartResponse) cartResponse.textContent = '';
    }

    rows.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        cardsFromRow(r.value);
        render();
      });
    });
    cards.forEach(function (c) {
      c.addEventListener('change', function () { rowFromCards(); render(); });
    });

    /* Pre-order: /cart/add.js with the form, then the cart page (as the book-set page) */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!chosen()) { alerts.show('incomplete'); return; }
      addBtn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) { if (!res.ok) throw new Error('Add to cart failed'); return res.json(); })
        .then(function () {
          alerts.show('added');
          setTimeout(function () { window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart'; }, 200);
        })
        .catch(function () { if (cartResponse) cartResponse.textContent = alerts.message('error'); })
        .then(function () { addBtn.removeAttribute('aria-busy'); });
    });

    /* Shop Pay / more payment options: blocked (and explained) while nothing is chosen */
    if (pay) pay.addEventListener('click', function (e) {
      if (chosen()) return;
      e.preventDefault();
      e.stopPropagation();
      alerts.show('incomplete');
    }, true);

    /* Load with the variant named in the URL (?variant=<id>, as the homepage links do), else Both Sets, else the first row */
    var wanted = null;
    try { var vid = new URLSearchParams(window.location.search).get('variant'); if (vid) wanted = rows.filter(function (r) { return r.getAttribute('data-variant') === vid; })[0] || null; } catch (e) {}
    var start = wanted || rowFor('both') || rows[0];
    start.checked = true;
    cardsFromRow(start.value);
    render();
  }

  /* ---------------------------------------------------------------- pre-order questions (several may be open) */
  function initFaq(scope) {
    $$('[data-hh-faq] .hh-faq__btn', scope).forEach(function (btn) {
      if (btn.hhReady) return;
      btn.hhReady = true;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        d.getElementById(btn.getAttribute('aria-controls')).hidden = open;
      });
    });
  }

  /* ---------------------------------------------------------------- review dots (phones scroll; desktop shows all three) */
  function initReviews(scope) {
    $$('[data-hh-tm-track]', scope).forEach(function (track) {
      if (track.hhReady) return;
      track.hhReady = true;
      var wrap = track.closest('.hh-tm');
      var cards = $$('.hh-tm-card', track);
      var dots = $$('.hh-tm__dot', wrap);
      function mark(i) { dots.forEach(function (b, k) { b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); }); }
      dots.forEach(function (b, i) {
        b.addEventListener('click', function () {
          mark(i);
          track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
      var raf = 0;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          if (track.scrollWidth <= track.clientWidth) return;
          mark(Math.round(track.scrollLeft / track.clientWidth));
        });
      }, { passive: true });
    });
  }

  function initMain(root) {
    if (root.hhReady) return;
    root.hhReady = true;
    var alerts = makeAlert(root);
    initGallery(root);
    initChooser(root, alerts);
  }

  function init(scope) {
    $$('[data-hh-sets]', scope).forEach(initMain);
    if (scope.matches && scope.matches('[data-hh-sets]')) initMain(scope);
    initFaq(scope);
    initReviews(scope);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); });
  else init(d);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
